/* eslint-disable complexity */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable react/display-name */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext, useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { scroller } from 'react-scroll';
import {
  SCROLL_INLINE_CALENDAR,
  CHOOSE_YOUR_OPTIONS_COMPONENT,
} from '../../../../config/constants/scroll';
import COOKIES from '../../../../config/cookies/cookies';
import {
  BUYNOW_EXCL,
  BUY_EXCL,
  CHOOSE_YOUR_OPTIONS,
  CLAIM,
  NIBBLE_TIMER,
  NIBBLE_TRACKING_FLAG,
} from '../../../../config/text/text';
import { trackEvent, updateDod } from '../../../../helpers/analytics';
import useCheckMobile from '../../../../helpers/checkMobile';
import { isCreditecDeal } from '../../../../helpers/creditec';
import {
  isBookingCalendarChooseDateDeal,
  getIsChooseYourOptionsDeal,
  getIsChooseYourProductDeal,
  useIsExpressBuy,
  getIsLeadGen,
  isBookingCalendarOnRedemptionDeal,
} from '../../../../helpers/deals';
import {
  getScreenBreakpoint,
  isMobileViewport,
  useScreenBreakpoint,
} from '../../../../helpers/screen';
import ThemeContext from '../../../../providers/ThemeProvider';
import PrimaryButton from '../../../_generic/button/PrimaryButton';
import {
  dealType,
  isNibbleEnabled,
  isNibbleEnabledDealLevel,
  nibbleDwellTimer,
} from '../../../nibble/NibbleHelper';
import NibbleWidget from '../../../nibble/NibbleWidget';
import CreditecButton from './CreditecButton';
import DealBuyButton from './DealBuyButton';
import DealChooseYourOptionsButton from './DealChooseYourOptionsButton';
import DealExpressBuyButtonDynamic from './DealExpressBuyButtonDynamic';
import DealLeadGen from './DealLeadGen';
import DealViewAvailabilityButton from './DealViewAvailabilityButton';
import ExpressCheckoutText from './ExpressCheckoutText';

const BUTTON_TYPES = {
  bookingCalendarOnRedemption: 'bookingCalendarOnRedemption',
  chooseYourOptions: 'chooseYourOptions',
  chooseYourProduct: 'chooseYourProduct',
  chooseYourProductWithSelection: 'chooseYourProductWithSelection',
  creditec: 'creditec',
  default: 'default',
  expressBuy: 'expressBuy',
  giftsExpressBuy: 'giftsExpressBuy',
  leadGen: 'leadGen',
  viewAvailability: 'viewAvailability',
};

const SIZE_LARGEST = 'size-largest';

const MainDealCombinedBuyButton = ({
  deal = {},
  className = '',
  quantityPosition = 'bottom',
  position,
  selectedOptions = [],
  differenceCreditAmount = 0,
  onSetShowMultiError = () => {},
  buttonRef,
  isTypeMobile = false,
  isClaim = false,
  pageDetails,
  rowSelection,
  quickBuyButtonRef,
  targetScroll = CHOOSE_YOUR_OPTIONS_COMPONENT,
  isOptionSelected = false,
  columnSelection,
  mainDealGiftButton,
  isProductPage,
  setShowEmptyMessage,
  isSoldOut = false,
  isModernVipVariant = false,
  isGoogleHotel,
  searchParams,
  viewAvailabilityButtonRef,
  setIsCYOSelected,
  paymentData = null,
  isCheckReady = true,
  isExpressDealPage = false,
  setIsExpressPayLoaded,
  isExpressPayLoaded,
  isNibbleAppeared = false,
  setIsNibbleAppeared,
  didTrackNibble = false,
  hasTracked = false,
  didTrackNibblePromtClick = false,
}) => {
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const isVipUser = useSelector((state) => state?.user?.userprofile?.vipUser);
  const allowExpressBuy = useIsExpressBuy(deal.id, isAuthenticated)
    ?.expressBuyable;
  const isGiftExpressBuyable = useIsExpressBuy(deal.id, isAuthenticated)
    ?.giftClaimable;
  const theme = useContext(ThemeContext);
  const [showNibble, setShowNibble] = useState(false);
  const isMobile = useCheckMobile(false);

  let buyButton;
  const HIDE_DESKTOP = 'hide-desktop';
  const isChooseYourProduct = getIsChooseYourProductDeal(deal);
  const isChooseYourOptions = getIsChooseYourOptionsDeal(deal);
  const isBookingCalendarChooseDate = isBookingCalendarChooseDateDeal(deal);
  const isBookingCalendarOnRedemption = isBookingCalendarOnRedemptionDeal(deal);

  useEffect(() => {
    const exactlyOneSelected =
      selectedOptions.filter((quantity) => quantity > 0).length === 1;
    let isMounted = true;

    // The following block of is responsible for adding Nibble button to multi CYO for mobile only
    if (isTypeMobile && exactlyOneSelected) {
      nibbleDwellTimer().then(() => {
        if (
          isTypeMobile &&
          isNibbleEnabledDealLevel(
            deal,
            deal.products[selectedOptions.findIndex((qty) => qty > 0)]?.id,
            isVipUser,
          )
        ) {
          setShowNibble(true);
        }
      });
      // The following block of is responsible for adding Nibble button to Single deals
    } else if (dealType(deal) === null) {
      nibbleDwellTimer().then(() => {
        if (
          isNibbleEnabled(deal, deal?.products[0]?.id, isVipUser, true) &&
          !didTrackNibble.current
        ) {
          trackEvent('nibble_button_would_have_loaded');
          didTrackNibble.current = true;
        }
        if (
          isMounted &&
          isNibbleEnabled(deal, deal?.products[0]?.id, isVipUser)
        ) {
          setShowNibble(true);
          if (!hasTracked.current) {
            trackEvent('nibble_button_appear');
            hasTracked.current = true;
          }
        }
      });
    } else {
      setShowNibble(false);
    }

    return () => {
      isMounted = false;
    };
  }, [isTypeMobile, selectedOptions, isAuthenticated, deal]);

  useEffect(() => {
    if (
      (buyButton === BUTTON_TYPES.chooseYourProductWithSelection ||
        buyButton === BUTTON_TYPES.chooseYourProduct) &&
      isExpressDealPage
    ) {
      if (!isExpressPayLoaded && selectedOptions.reduce((a, b) => a + b, 0) > 0)
        setIsExpressPayLoaded(true);
      else if (!selectedOptions.reduce((a, b) => a + b, 0) > 0)
        setIsExpressPayLoaded(false);
    }
  }, [selectedOptions]);

  const shouldShowGiftButton = (
    isCheckReady,
    isExpressDealPage,
    isAuthenticated,
    buyButton,
  ) => {
    if (isCheckReady) return false;
    if (!isExpressDealPage || isAuthenticated) return true;

    return (
      buyButton !== BUTTON_TYPES.default &&
      buyButton !== BUTTON_TYPES.chooseYourProductWithSelection
    );
  };

  if (getIsLeadGen(deal)) {
    buyButton = BUTTON_TYPES.leadGen;
  } else if (isAuthenticated && allowExpressBuy && !pageDetails.isTravel) {
    buyButton = BUTTON_TYPES.expressBuy;
  } else if (
    isAuthenticated &&
    isGiftExpressBuyable &&
    !pageDetails.isTravel &&
    isClaim &&
    !getIsChooseYourOptionsDeal(deal) &&
    !getIsChooseYourProductDeal(deal)
  ) {
    buyButton = BUTTON_TYPES.giftsExpressBuy;
  } else if (isChooseYourProduct) {
    const hasSelection = selectedOptions.reduce((a, b) => a + b, 0) > 0;
    if (hasSelection) {
      buyButton = BUTTON_TYPES.chooseYourProductWithSelection;
    } else {
      buyButton = BUTTON_TYPES.chooseYourProduct;
    }
  } else if (isChooseYourOptions) {
    buyButton = BUTTON_TYPES.chooseYourOptions;
  } else if (isBookingCalendarChooseDate) {
    buyButton = BUTTON_TYPES.viewAvailability;
  } else if (isBookingCalendarOnRedemption) {
    buyButton = BUTTON_TYPES.bookingCalendarOnRedemption;
  } else if (isCreditecDeal(deal)) {
    buyButton = BUTTON_TYPES.creditec;
  } else {
    buyButton = BUTTON_TYPES.default;
  }

  const renderComplianceText =
    isExpressDealPage &&
    buyButton &&
    buyButton !== BUTTON_TYPES.chooseYourProduct &&
    buyButton !== BUTTON_TYPES.viewAvailability;

  if (
    (buyButton === BUTTON_TYPES.chooseYourOptions ||
      buyButton === BUTTON_TYPES.chooseYourProduct) &&
    isProductPage
  ) {
    return (
      <DealBuyButton
        buttonRef={buttonRef}
        buttonType={isTypeMobile ? 'mobile' : 'top'}
        className={classNames(SIZE_LARGEST, className)}
        columnSelection={columnSelection}
        deal={deal}
        isClaim={isClaim}
        isProductPage={isProductPage}
        isSoldOut={isSoldOut}
        isTypeMobile={isTypeMobile}
        position={position}
        rowSelection={rowSelection}
        selectedOptions={selectedOptions}
        setShowEmptyMessage={setShowEmptyMessage}
        stickyButton
        targetScroll={targetScroll}
        text={isClaim ? CLAIM : null}
      />
    );
  }

  // Display CYO button only if the deal is from a non-shop page
  if (buyButton === BUTTON_TYPES.chooseYourOptions) {
    return (
      <>
        <DealChooseYourOptionsButton
          buttonRef={buttonRef}
          buyButton={buyButton}
          className={classNames('size-large', className)}
          compact={false}
          deal={deal}
          isAuthenticated={isAuthenticated}
          isExpressDealPage={isExpressDealPage}
          isModernVipVariant={isModernVipVariant}
          isOptionSelected={isOptionSelected}
          isTypeMobile={isTypeMobile}
          pageDetails={pageDetails}
          paymentData={paymentData}
          selectedOptions={selectedOptions}
          setIsCYOSelected={setIsCYOSelected}
          stickyButton
          targetScroll={targetScroll}
        />
      </>
    );
  }

  let buttonText = isMobile ? BUYNOW_EXCL : BUY_EXCL;
  if (isClaim) buttonText = CLAIM;

  return (
    <div
      className={`maindeal-combined-button sticky-button ${
        isTypeMobile ? HIDE_DESKTOP : ''
      }`}
    >
      {isTypeMobile && <div id="shop-dev-container" />}
      {{
        [BUTTON_TYPES.leadGen]: () => (
          <DealLeadGen
            buttonRef={buttonRef}
            deal={deal}
            isTravel={pageDetails?.isTravel}
          />
        ),
        [BUTTON_TYPES.expressBuy]: () => (
          <>
            <div className="express-row">
              {!isClaim && (
                <div className="express-col-l">
                  <DealExpressBuyButtonDynamic
                    buttonRef={quickBuyButtonRef}
                    buttonType={isTypeMobile ? 'mobile' : 'top'}
                    className={className}
                    deal={deal}
                    quantityPosition={quantityPosition}
                  />
                </div>
              )}
              <div className="express-col-r">
                <DealBuyButton
                  buttonRef={buttonRef}
                  buttonType={isTypeMobile ? 'mobile' : 'top'}
                  className={classNames('size-largest', className)}
                  deal={deal}
                  isSoldOut={isSoldOut}
                  text={isClaim ? CLAIM : BUY_EXCL}
                />
              </div>
            </div>
            <style jsx>{`
              @media (max-width: ${theme.breakpoints.smDown}) {
                .express-row {
                  display: flex;
                  flex-wrap: wrap;
                  margin-top: 35px;
                  width: 100%;
                }
                .express-col-l {
                  flex: 0 0 66%;
                  max-width: 66%;
                }
                .express-col-r {
                  flex: 0 0 33%;
                  max-width: 33%;
                  margin-left: 1%;
                }
              }
            `}</style>
          </>
        ),

        [BUTTON_TYPES.giftsExpressBuy]: () => (
          <>
            <div className="express-row">
              {isClaim && isGiftExpressBuyable && differenceCreditAmount > 0 && (
                <div className="express-col-l">
                  <DealExpressBuyButtonDynamic
                    buttonRef={buttonRef}
                    buttonType={isTypeMobile ? 'mobile' : 'top'}
                    className={className}
                    deal={deal}
                    isClaim={isClaim}
                    quantityPosition={quantityPosition}
                  />
                </div>
              )}
            </div>
            <style jsx>{`
              @media (max-width: ${theme.breakpoints.smDown}) {
                .express-row {
                  display: flex;
                  flex-wrap: wrap;
                  margin-top: 35px;
                  width: 100%;
                }
                .express-col-l {
                  flex: 0 0 66%;
                  max-width: 66%;
                }
              }
            `}</style>
          </>
        ),
        [BUTTON_TYPES.chooseYourProduct]: () => (
          <PrimaryButton
            aria-label={CHOOSE_YOUR_OPTIONS}
            buttonRef={buttonRef}
            className={classNames(SIZE_LARGEST, className)}
            disabled={isSoldOut}
            onClick={() => {
              const breakpoint = getScreenBreakpoint();
              if (localStorage.getItem(NIBBLE_TRACKING_FLAG) !== 'true') {
                trackEvent('click_buy');
              }
              updateDod({});
              scroller.scrollTo(targetScroll, {
                delay: 100,
                duration: 1_000,
                offset: breakpoint === 'sm' ? -300 : 0,
                smooth: true,
              });
              onSetShowMultiError(true);
            }}
          >
            {buttonText}
          </PrimaryButton>
        ),
        [BUTTON_TYPES.chooseYourProductWithSelection]: () => (
          <>
            <DealBuyButton
              buttonRef={buttonRef}
              buttonType={isTypeMobile ? 'mobile' : 'top'}
              className={classNames({
                [className]: !isExpressDealPage,
                'cyo-selection deal-main-deal__buy full-width common-express-style': isExpressDealPage,
                [SIZE_LARGEST]: !isExpressDealPage,
              })}
              deal={deal}
              isExpressDealPage={isExpressDealPage}
              isSoldOut={isSoldOut}
              isTypeMobile={isTypeMobile}
              nibbleAppeared={isNibbleAppeared}
              paymentInstruments={paymentData}
              position={selectedOptions}
              selectedOptions={selectedOptions}
              text={buttonText}
            />
            {isTypeMobile &&
              selectedOptions.filter((quantity) => quantity > 0).length === 1 &&
              showNibble && (
                <NibbleWidget
                  deal={deal}
                  setIsNibbleAppeared={setIsNibbleAppeared}
                  variantId={
                    deal.products[
                      selectedOptions.findIndex((quantity) => quantity > 0)
                    ]?.id
                  }
                />
              )}
          </>
        ),
        [BUTTON_TYPES.bookingCalendarOnRedemption]: () =>
          isMobile ? (
            <DealViewAvailabilityButton
              buttonRef={buttonRef}
              className={className}
              condition={
                pageDetails?.isTravel && !isTypeMobile
                  ? SCROLL_INLINE_CALENDAR
                  : null
              }
              deal={deal}
              isModernVipVariant={isModernVipVariant}
              isOptionSelected={isOptionSelected}
              ref={viewAvailabilityButtonRef}
              setIsCYOSelected={setIsCYOSelected}
            />
          ) : (
            <span />
          ),
        [BUTTON_TYPES.viewAvailability]: () => (
          <>
            <DealViewAvailabilityButton
              buttonRef={buttonRef}
              buyButton={buyButton}
              className={className}
              condition={
                pageDetails?.isTravel && !isTypeMobile
                  ? SCROLL_INLINE_CALENDAR
                  : null
              }
              deal={deal}
              isExpressDealPage={isExpressDealPage}
              isExpressPayLoaded={isExpressPayLoaded}
              isGoogleHotel={isGoogleHotel}
              isModernVipVariant={isModernVipVariant}
              isNibbleAppeared={isNibbleAppeared}
              isOptionSelected={isOptionSelected}
              mainDealGiftButton={mainDealGiftButton}
              paymentData={paymentData}
              ref={viewAvailabilityButtonRef}
              searchParams={searchParams}
              setIsCYOSelected={setIsCYOSelected}
              setIsExpressPayLoaded={setIsExpressPayLoaded}
              setIsNibbleAppeared={setIsNibbleAppeared}
            />
          </>
        ),
        [BUTTON_TYPES.creditec]: () => <CreditecButton buttonRef={buttonRef} />,
        [BUTTON_TYPES.default]: () => (
          <>
            <DealBuyButton
              buttonRef={buttonRef}
              buttonType={isTypeMobile ? 'mobile' : 'top'}
              className={classNames({
                [className]: !isExpressDealPage,
                'singleSelectSec deal-main-deal__buy full-width common-express-style': isExpressDealPage,
                [SIZE_LARGEST]: !isExpressDealPage,
              })}
              deal={deal}
              isCheckReady={isCheckReady}
              isClaim={isClaim}
              isExpressDealPage={isExpressDealPage}
              isSoldOut={isSoldOut}
              isTypeMobile={isTypeMobile}
              nibbleAppeared={isNibbleAppeared}
              paymentInstruments={paymentData}
              selectedOptions={selectedOptions}
              setIsExpressPayLoaded={setIsExpressPayLoaded}
              text={isClaim ? CLAIM : null}
            />
            {dealType(deal) === null && showNibble && (
              <NibbleWidget
                deal={deal}
                setIsNibbleAppeared={setIsNibbleAppeared}
              />
            )}
          </>
        ),
      }[buyButton]()}
      {shouldShowGiftButton(
        isCheckReady,
        isExpressDealPage,
        isAuthenticated,
        buyButton,
      ) && mainDealGiftButton}

      {isMobile && !isCheckReady && renderComplianceText && (
        <ExpressCheckoutText
          isAuthenticated={isAuthenticated}
          margin={
            isAuthenticated
              ? '-8px 0px 0px 6px'
              : deal?.giftable
              ? '0px 0px 0px 6px'
              : '-5px 0 0 6px'
          }
          paddingTop="4px"
          shouldRenderComplianceText={renderComplianceText}
        />
      )}
    </div>
  );
};

MainDealCombinedBuyButton.propTypes = {
  buttonRef: PropTypes.object,
  className: PropTypes.string,
  columnSelection: PropTypes.number,
  deal: PropTypes.object,
  differenceCreditAmount: PropTypes.number,
  isClaim: PropTypes.bool,
  isGoogleHotel: PropTypes.bool,
  isModernVipVariant: PropTypes.bool,
  isOptionSelected: PropTypes.bool,
  isProductPage: PropTypes.bool,
  isTypeMobile: PropTypes.bool,
  mainDealGiftButton: PropTypes.object,
  onSetShowMultiError: PropTypes.func,
  pageDetails: PropTypes.object,
  position: PropTypes.number,
  quantityPosition: PropTypes.string,
  quickBuyButtonRef: PropTypes.object,
  rowSelection: PropTypes.number,
  searchParams: PropTypes.object,
  selectedOptions: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  setIsCYOSelected: PropTypes.func,
  setShowEmptyMessage: PropTypes.func,
  targetScroll: PropTypes.any,
};

export default MainDealCombinedBuyButton;
